import { CommodityFilterStatusFlag } from '@bechtel/types';
export const fitupMilestoneStats: { status: CommodityFilterStatusFlag; value: number }[] = [
  {
    status: CommodityFilterStatusFlag.FITUP_REQUESTED,
    value: 0,
  },
  {
    status: CommodityFilterStatusFlag.FITUP_INSPECTION,
    value: 0,
  },
  {
    status: CommodityFilterStatusFlag.SENT_BACK_TO_PIPING,
    value: 0,
  },
  {
    status: CommodityFilterStatusFlag.READY_TO_WELD,
    value: 0,
  },
];

export const installMilestoneStats: { status: CommodityFilterStatusFlag; value: number }[] = [
  {
    status: CommodityFilterStatusFlag.CLAIMED,
    value: 0,
  },
  {
    status: CommodityFilterStatusFlag.VT_SENT_BACK,
    value: 0,
  },
  {
    status: CommodityFilterStatusFlag.VT_APPROVED,
    value: 0,
  },
];
